import { Inject, Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private _http = inject(HttpClient);

  constructor(@Inject('API_BASE_URL') private _baseUrl: string) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T>(resource: string, params: any = {}): Observable<T> {
    params.headers = new HttpHeaders({
      'Accept-Language': 'fr, en',
    });
    params.withCredentials = true;

    return this._http.get<T>(this._baseUrl + '/' + resource, params).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post<TResponse, TParams = TResponse>(resource: string, params?: TParams, options: any = {}): Observable<TResponse> {
    if (!resource.indexOf('register')) {
      options.headers = new HttpHeaders({
        'Accept-Language': 'fr, en',
      });
    }
    options.withCredentials = true;
    return this._http.post<TResponse>(this._baseUrl + '/' + resource, params, options).pipe(catchError(this.handleError));
  }

  put<T>(resource: string, params?: T, options: any = {}): Observable<T> {
    if (!resource.indexOf("register")) {
      options.headers = new HttpHeaders({
        "Accept-Language": "fr, en",
      });
    }
    options.withCredentials = true;
    return this._http
        .put<T>(this._baseUrl + "/" + resource, params, options)
        .pipe(catchError(this.handleError));
  }

  patch<TResponse, TParams = TResponse>(resource: string, params?: TParams, options: any = {}): Observable<TResponse> {
    options.withCredentials = true;
    return this._http.patch<TResponse>(this._baseUrl + '/' + resource, params, options).pipe(catchError(this.handleError));
  }

  delete<T>(resource: string, params?: object): Observable<T> {
    const options = { ...params, withCredentials: true };
    return this._http.delete<T>(this._baseUrl + '/' + resource, options).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleError(error: any): Promise<any> {
    if (error.status === 422) {
      return Promise.reject(error.error.message || error.message || error);
    }
    return Promise.reject(error);
  }
}
